import { Link, NavLink, Route, Routes } from "react-router-dom";
import HomePage from "./pages/Home";
import InboxPage from "./pages/Inbox";
import MessageDetailPage from "./pages/MessageDetail";
import AboutPage from "./pages/About";
import PrivacyPolicyPage from "./pages/PrivacyPolicy";
import TermsOfServicePage from "./pages/TermsOfService";
import { useAuth } from "./auth/AuthContext";
import SignInButton from "./ui/SignInButton";
import SignOutButton from "./ui/SignOutButton";

function App() {
  const { token } = useAuth();

  return (
    <div className="app">
      <header className="app-header">
        <div className="logo">SiftMyMail</div>
        <nav className="nav">
          <NavLink to="/" end>
            Home
          </NavLink>
          <NavLink to="/inbox">Inbox</NavLink>
          <NavLink to="/about">About</NavLink>
        </nav>
        <div className="auth-actions">{token ? <SignOutButton /> : <SignInButton />}</div>
      </header>
      <main className="app-main">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/inbox" element={<InboxPage />} />
          <Route path="/messages/:id" element={<MessageDetailPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsOfServicePage />} />
        </Routes>
      </main>
      <footer className="app-footer">
        <p>© 2025 Christy and Ryan, LLC · Texas, United States</p>
        <div className="footer-links" aria-label="Legal links">
          <Link to="/privacy">Privacy Policy</Link>
          <span aria-hidden="true">•</span>
          <Link to="/terms">Terms of Service</Link>
        </div>
      </footer>
    </div>
  );
}

export default App;
